module.exports = __webpack_public_path__ + "img/8db6e7bd1c90b1b867f57a38e7150b68.png";